import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';

import 'nprogress/nprogress.css';
import App from 'src/App';
import { SidebarProvider } from 'src/contexts/SidebarContext';
import * as serviceWorker from 'src/serviceWorker';
import UserContextProvider from './contexts/userContext';
import TokenContextProvider from './contexts/tokenContext';
import ProductIdContextProvider from './contexts/ProductIdContextProvider';

ReactDOM.render(
  <HelmetProvider>
    <SidebarProvider>
      <BrowserRouter>
        <UserContextProvider>
          <TokenContextProvider>
            <ProductIdContextProvider>
              <App />
            </ProductIdContextProvider>
          </TokenContextProvider>
        </UserContextProvider>
      </BrowserRouter>
    </SidebarProvider>
  </HelmetProvider>,
  document.getElementById('root')
);

// PWA service worker: intentionally left UNREGISTERED for now.
//
// The manifest, icons and iOS meta tags make "Add to Home Screen" work as a
// standalone app already. A precached/offline service worker is deferred because:
//   1. This is react-scripts 5 with no Workbox/PWA template, so `react-scripts
//      build` does NOT emit `/service-worker.js` — enabling register() here
//      would just 404. A real precache SW needs Workbox tooling (a new dependency).
//   2. There is no test server; a bad SW can serve stale assets to ALL browsers
//      (desktop included). Enabling it requires the plan's desktop gate 3.7:
//      verify the update/unregister flow on a device before shipping.
// unregister() is also self-healing: it clears any SW a previous build registered.
serviceWorker.unregister();
